import Application from "../../Application";
import { ICredentialService } from "../../service/credential/CredentialService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class LogoutInteractor {
  private credentialService: ICredentialService;
  private notificationService: INotificationService;

  constructor({
    credentialService,
    notificationService
  }: {
    credentialService: ICredentialService;
    notificationService: INotificationService;
  }) {
    this.credentialService = credentialService;
    this.notificationService = notificationService;
  }

  async execute() {
    try {
      await this.credentialService.setLoggedIn(false);
      const language = await this.credentialService.getLanguage();
      window.location.replace(
        `${import.meta.env.BASE_URL}device-login?lang=${language}`
      );
    } catch (e: any) {
      this.notificationService.showError(e.message);
      throw e;
    }
  }
}
